export const SORT_BY_NAME = "ByName";
export const SORT_BY_DATE = "ByDate";